import {Component} from 'lowkey-component'
import Swiper, {Mousewheel, Pagination} from 'swiper'

import {MediaQuery} from '@services/MediaQuery'
import {createVoiceState} from '@services/VoiceState'

export class Voice extends Component {
  private swiper: Swiper | null = null;
  private mq = MediaQuery.create();
  private slides: HTMLDivElement[] = [];
  private voiceState = createVoiceState();

  constructor(element: HTMLDivElement) {
    super(element);
    this.onClick = this.onClick.bind(this);
  }

  didMount() {
    this.slides = Array.from(this.element.querySelectorAll('.swiper-slide'));

    this.swiper = new Swiper(this.element, {
      modules: [Pagination, Mousewheel],
      slidesPerView: 'auto',
      preventInteractionOnTransition: true,
      mousewheel: {
        forceToAxis: true,
      },
      spaceBetween: this.mq.isDesktop() ? 33 : 27,
      grabCursor: true,
      pagination: {
        el: '.swiper-progressbar',
        type: 'progressbar',
      },
    });

    this.slides.map((slide, index) => {
      const link = slide.querySelector('.m-voice-item') as HTMLAnchorElement;
      if (link) {
        link.dataset['index'] = index.toString();
        link.addEventListener('click', this.onClick);
      }
    });
  }

  onClick(e: Event) {
    if (e.currentTarget) {
      const target = e.currentTarget as HTMLAnchorElement;
      const index = parseInt(target.dataset['index'] || '0', 10);
      this.voiceState.updateCurrentVoiceModalIndex(index);
      this.voiceState.updateIsOpenVoiceModal(true);
    }
  }

  didUnmount() {
    this.slides.map((slide, index) => {
      const link = slide.querySelector('.a-viewmore');
      link?.removeEventListener('click', this.onClick);
    });
    this.swiper?.destroy();
  }
}
